import React from 'react';
import { MoonStarIcon } from 'lucide-react';
import { contact } from '../data/contact';
interface FooterProps {
  lockup: string;
}
export function Footer({
  lockup
}: FooterProps) {
  return <footer className="border-t border-silver/10 bg-carbon pb-16 pt-16" data-id="element-36" data-mp="32oe2m2kq2nec">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-37" data-mp="32m1c310wf4po">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between" data-id="element-38" data-mp="36pzb7bq84fiq">
          <div className="max-w-md" data-id="element-39" data-mp="3ugbrpazjbkkx">
            <div className="flex items-center gap-3" data-id="element-40" data-mp="3ud7hnwze1umc">
              <MoonStarIcon className="h-5 w-5 text-accent-soft" aria-hidden="true" data-id="element-41" data-mp="37ft3219eq1n" />
              <span className="font-display text-[0.72rem] font-medium uppercase tracking-[0.24em] text-frost sm:text-sm" data-id="element-42" data-mp="3lggaaofdytcg">
                {lockup}
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-silver/80" data-id="element-43" data-mp="29xvps9u757nq">
              Templo de Ayuda Espiritual. Consultas, rituales y orientación
              espiritual de carácter tradicional y personalizado.
            </p>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 lg:gap-14" data-id="element-44" data-mp="3gapfjptkcwj5">
            <div data-id="element-45" data-mp="3gck0h44u4on8">
              <h2 className="text-[0.68rem] font-medium uppercase tracking-[0.24em] text-silver/60" data-id="element-46" data-mp="3v7q7nufo2ti5">
                Navegación
              </h2>
              <ul className="mt-4 space-y-3 text-sm text-silver" data-id="element-47" data-mp="3q7u23qrbmu0h">
                <li data-id="element-48" data-mp="82ienymgqkhh">
                  <a href="#inicio" className="transition-colors hover:text-frost focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft" data-id="element-49" data-mp="81yvyfozns2e">
                    Inicio
                  </a>
                </li>
                <li data-id="element-50" data-mp="ct783jhpdrj9">
                  <a href="#servicios" className="transition-colors hover:text-frost focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft" data-id="element-51" data-mp="cv1ruuh8ndlr">
                    Prácticas
                  </a>
                </li>
                <li data-id="element-52" data-mp="tw5xq4ifnmlo">
                  <a href="#contacto" className="transition-colors hover:text-frost focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft" data-id="element-53" data-mp="two2jpj5v957">
                    Contacto
                  </a>
                </li>
                <li data-id="element-54" data-mp="18ksod2dig0s7">
                  <a href="#politicas" className="transition-colors hover:text-frost focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft" data-id="element-55" data-mp="18lbw5q9g58si">
                    Políticas del sitio
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-56" data-mp="1riv9h62xtdkq">
              <h2 className="text-[0.68rem] font-medium uppercase tracking-[0.24em] text-silver/60" data-id="element-57" data-mp="1rjemc8dqdbrw">
                Contacto
              </h2>
              <ul className="mt-4 space-y-3 text-sm text-silver" data-id="element-58" data-mp="3oczo179lsb4g">
                <li data-id="element-59" data-mp="3tb9mbqqmjrua">
                  <a href={contact.whatsappHref} target="_blank" rel="noreferrer" className="transition-colors hover:text-frost" data-id="element-60" data-mp="3tarquwbsdhnf">
                    WhatsApp {contact.whatsapp}
                  </a>
                </li>
                <li data-id="element-61" data-mp="21kpgzxlpcb59">
                  <a href={contact.phoneHref} className="transition-colors hover:text-frost" data-id="element-62" data-mp="1wnp5h7632g6r">
                    {contact.phone}
                  </a>
                </li>
                <li data-id="element-63" data-mp="2pdfp1vqhiaa9">
                  <a href={contact.emailHref} className="break-all transition-colors hover:text-frost" data-id="element-64" data-mp="2pcw4065jf5s0">
                    {contact.email}
                  </a>
                </li>
                <li className="text-silver/80" data-id="element-65" data-mp="18y4ouuxejv0n">{contact.address}</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 border-t border-silver/10 pt-7" data-id="element-66" data-mp="13y05mx540m6q">
          <p className="text-xs leading-relaxed text-silver/60" data-id="element-67" data-mp="2rvra3mqob2j1">
            Sitio dirigido exclusivamente a personas mayores de edad. Consultas y
            prácticas de carácter espiritual y tradicional. Consulta nuestros{' '}
            <a href="#terminos" className="underline hover:text-frost" data-id="element-68" data-mp="2ivufl4hlr9g2">
              términos y condiciones
            </a>{' '}
            y nuestra{' '}
            <a href="#privacidad" className="underline hover:text-frost" data-id="element-69" data-mp="2nrrt731he1p5">
              política de privacidad
            </a>
            .
          </p>
          <p className="mt-4 text-xs text-silver/50" data-id="element-70" data-mp="3fk0ow4pgyq0o">
            © {new Date().getFullYear()} {contact.brandName}. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}